import { type NavigationGuard } from 'vue-router';
import { useAuthenticationAction, useAuthenticationQuery } from '@/composables/authentication';
import { Navigation } from '@/router/navigation';
import { PermissionName } from '@containex/portal-backend-dto';

export function requirePermission(requiredPermission: PermissionName): NavigationGuard {
    return (_to, _from, next) => {
        const authenticationAction = useAuthenticationAction();
        const authenticationQuery = useAuthenticationQuery();

        if (!authenticationQuery.isUserLoggedIn.value) {
            return next(Navigation.Login);
        }
        if (authenticationAction.hasPermission(requiredPermission)) {
            return next();
        }
        next(Navigation.Unauthorized);
    };
}
